<template>
<div>
  <v-system-bar dark class='overline' >
    Your appointment
  </v-system-bar>
  <template v-if='appointment && appointment.id' >
    <template v-if='isRecurring' >
      <v-list three-line>
        <v-list-tile >
          <v-list-tile-avatar><v-icon>check</v-icon></v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              Recurring appointment created
            </v-list-tile-title>
            <v-list-tile-sub-title>
              First appointment: {{ formatFromTo(appointment.start_time, appointment.end_time) }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              {{ appointment.num_recurrances }} appointments recurring {{ appointment.recurrance_rate.toLowerCase() }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider/>
      <v-card-actions  >
        <v-btn @click='$emit("reset")' color='success' >
          <v-icon >arrow_back</v-icon>
          Add another</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat @click='$emit("close")'>Done</v-btn>
      </v-card-actions>
    </template>
    <template v-else >
      <small-appointment-card
        v-model='appointment'
        v-if='appointment && appointment.id'
        @close='$emit("close")' >

        <template slot='card-actions' >
          <v-divider/>
          <v-card-actions  >
            <v-btn @click='$emit("reset")' color='success' >
              <v-icon >arrow_back</v-icon>
              Add another</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat @click='$emit("close")'>Done</v-btn>
          </v-card-actions>
        </template>

      </small-appointment-card>
    </template>
  </template>
</div>
<!-- <v-list class='py-0' dense>
  <appointment-list-item :appointment='appointment' :with-action='false' class='my-2' >

    <v-list-tile-title v-if='isRecurring' slot='title' >
      Created {{ appointment.num_recurrances + 1 }} appointments
      <small v-if='appointment.recurrance_rate' >
        (recurring {{ appointment.recurrance_rate.toLowerCase() }})
      </small>
    </v-list-tile-title>
    <v-avatar slot='actions' >
      <v-icon color='green' >check_circle</v-icon>
    </v-avatar>
  </appointment-list-item>
  <v-divider></v-divider>
  <template v-if="!isRecurring" >
    <v-subheader class='overline' >Next steps</v-subheader>
    <action-list :appointment='appointment'
      :exclude="['bulk_reschedule', 'bulk_cancel', 'bulk_delete']"
      @close="$emit('close')" />
  </template>
  <v-divider></v-divider>
  <v-card flat>
    <v-card-actions>
      <v-btn @click='$emit("reset")' color='success' >
        <v-icon >arrow_back</v-icon>
        Add another</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat @click='$emit("close")'>Done</v-btn>
    </v-card-actions>
  </v-card>
</v-list> -->
</template>

<script>
// import AppointmentsMixin from '@/mixins/appointments'
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
// import ActionList from '@/components/appointment/actions/ActionList.vue'
import SmallAppointmentCard from '@/components/cards/SmallAppointmentCard.vue'

export default {
  name: 'AfterAppointmentActions',
  // mixins: [AppointmentsMixin],
  components: { AppointmentListItem, SmallAppointmentCard },
  props: {
    appointment: { type: Object, required: true }
  },
  data () {
    return {
      exclude: [
        'show_client',
        'reschedule',
        'cancel_appointment',
        'delete_appointment'
      ]
    }
  },
  methods: {
    itemAction (action) {
      action.onclick()
      this.$ga.event('appointment', action.title + ' clicked')
    }
  },
  computed: {
    isRecurring () {
      return (this.appointment.num_recurrances && this.appointment.num_recurrances > 0)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// After.vue?3f5840ed